import React, { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";

import { useTranslation } from "react-i18next";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import jwtInterceoptor from "../../components/shared/jwtInterceptor";

import moment from "moment";

import Swal from "sweetalert2";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import OrgContext from "../../organisation/OrgContext";
import { API } from "../../services/api";
import { useNavigate } from "react-router-dom";

import { frFR, enUS } from "@mui/x-data-grid";
import { toast, ToastContainer } from "react-toastify";
import { formatNumber } from "../../helpers/formater";
import { LinearProgress } from "@mui/material";
import useAuthHelper from "../../helpers/AuthHelper";
import header from "../../page/header";
import Papa from "papaparse";
import logo from "../../assets/images/ElmanagerLogo.png";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          x
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

function InvoicesList(props) {
  const { onlyCommercial, hadDeleteAccess, hadEditAccess } = useAuthHelper();

  console.log("listInvoices");
  const [t, i18n] = useTranslation();

  const { organisation } = useContext(OrgContext);

  const [invoices, setInvoices] = useState([]);

  const [status, setSatus] = useState([]);
  const [rowParam, setRowParam] = useState([]);

  const [currentSelectedStatus, setCurrentSelectedStatus] = useState(0);
  let [newStatus, setNewStatus] = useState(0);
  const [currentSelectedInvoice, setCurrentSelectedInvoice] = useState(0);
  const navigate = useNavigate();

  const [grandTotal, setGrandTotal] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  // visible columns
  const [visibleColumns, setVisibleColumns] = useState({
    __check__: true,
    "Numéro de facture": true,
    Client: true,
    "Date de Facture": true,
    "Date d'échéance": true,
    Montant: true,
    "Bon de livraison lié": true,
    action: true,
  });
  //store the visible columns
  useEffect(() => {
    onlyCommercial();

    const storedColumns = JSON.parse(
      localStorage.getItem("visibleColumnsVente"),
    );
    if (storedColumns) {
      setVisibleColumns(storedColumns);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("visibleColumnsVente", JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  const handleColumnVisibilityModelChange = (newModel) => {
    console.log(newModel);
    if (Object.keys(newModel).length === 0) {
      console.log(",,,,,,,,,,,,,,", newModel);
      newModel = {
        __check__: true,
        "Numéro de facture": true,
        Client: true,
        "Date de Facture": true,
        "Date d'échéance": true,
        Montant: true,
        "Bon de livraison lié": true,
        action: true,
      };
    }
    if (newModel) {
      console.log(visibleColumns);
      const updatedVisibleColumns = { ...visibleColumns, ...newModel };

      setVisibleColumns(updatedVisibleColumns);
      console.log("visible colonne state: ", updatedVisibleColumns);
    } else {
      console.error("newModel is undefined");
    }
  };

  //filtre de date
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [filteredInvoices, setFilteredInvoices] = useState(invoices);
  // Fonction pour gérer le filtrage a partir de la date
  const handleFilterDate = () => {
    let startDate = moment(dateDebut, "YYYY-MM-DD").startOf("day");
    let endDate = dateFin
      ? moment(dateFin, "YYYY-MM-DD").endOf("day")
      : moment().endOf("day");
    if (startDate.isAfter(endDate)) {
      toast.warning(
        t("La date de début ne peut pas être supérieure à la date de fin."),
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        },
      );
    }

    // Filtrer les données en fonction des dates
    if (dateDebut && (dateFin || endDate)) {
      const filteredData = invoices.filter((invoice) => {
        const invoiceDate = moment(invoice.created_at, "YYYY-MM-DD").startOf(
          "day",
        );
        if (endDate) {
          return invoiceDate.isBetween(startDate, endDate, null, "[]");
        } else {
          return invoiceDate.isSameOrAfter(startDate);
        }
      });

      if (filteredData.length === 0) {
        toast.warning(t("Aucune facture trouvée entre ces dates."), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }

      setFilteredInvoices(filteredData);
      console.log(filteredInvoices);
    } else {
      toast.error(t("Veuillez sélectionner les dates de début et de fin."), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  useEffect(() => {
    if (organisation.id) {
      fetchStatusInvoices();
      fetchInvoices();
    }
  }, []);

  const fetchInvoices = async () => {
    setLoadingData(true);
    const response = await jwtInterceoptor.get(
      `/data/user/factures/${organisation.id}`,
    );

    if (response.status === 200) {
      setInvoices(response.data.data);
    }
    setLoadingData(false);
  };

  const fetchStatusInvoices = async () => {
    const response = await jwtInterceoptor.get(`/data/user/status/factures`);

    if (response.status === 200) {
      setSatus(response.data.data);
    }
  };

  const deleteItem = async (inv) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await jwtInterceoptor.delete(
          `/data/user/factures/delete/${inv.id}`,
        );

        if (response.status === 200) {
          if (response.data.status == true) {
            let invs = invoices.filter((el) => el.id != inv.id);

            setInvoices(invs);

            Swal.fire(
              t("Deleted!"),
              t("Your record has been deleted."),
              "success",
            );

            return;
          }
        }

        Swal.fire({
          icon: "warning",
          title: "",
          text: t("Something went wrong!, try again"),
        });
      }
    });
  };

  const columns = [
    {
      field: "Numéro de facture",
      headerName: t("Numéro de facture"),
      valueGetter: (params) => params.row?.invoice_number,
      width: 180,
    },
    /*{
            field: 'Référence de facture',
            headerName: t("Référence de facture"),
            valueGetter: (params) => params.row?.invoice_number,
            width: 180,
        },*/
    {
      flex: 1,
      field: "numéro de pièce",
      headerName: t("Numéro de pièce"),
      valueGetter: (params) => `V${params.row?.id}`,
    },
    {
      flex: 1,
      field: "Client",
      headerName: t("Client"),
      valueGetter: (params) => params.row.client.companyName,
    },
    {
      flex: 1,
      field: "Date de Facture",
      headerName: t("Date de Facture"),
      valueGetter: (params) => params.row.created_at,
      valueFormatter: (params) => moment(params.value).format("DD/MM/YYYY"),
      type: "date",
    },
    {
      flex: 1,
      field: "Date d'échéance",
      headerName: t("Date d'échéance"),
      valueGetter: (params) =>
        `${moment(params.row.due_date).format("DD/MM/YYYY") || ""}`,
    },
    {
      flex: 1,
      field: "Montant",
      headerName: t("Montant"),
      valueGetter: (params) =>
        `${
          `${params.row.total_ttc.toFixed(2)} ${
            organisation?.currency?.code
          }` || ""
        }`,
    },
    {
      flex: 1,
      field: "Bon de livraison lié",
      hideable: true,
      headerName: t("Bon de livraison lier"),
      valueGetter: (params) => params.row.nobnlivraison,
    },
    {
      field: "action",
      headerName: t("ACTIONS"),
      width: 250,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onDelete = (e) => {
          if (!hadDeleteAccess()) {
            toast.error(
              t("Vous n'avez pas les droits pour supprimer cette facture ."),
              {
                position: "top-right",
                autoClose: 5000,
              },
            );
            return;
          }
          const inv = params.row;
          if (
            inv.payment[inv.payment.length - 1].status === 2 ||
            inv.payment[inv.payment.length - 1].status === 3
          ) {
            toast.error(
              "Vous pouvez pas supprimer une facture payé ou payé en partie",
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
              },
            );
          } else {
            return deleteItem(inv);
          }
        };

        const onEdit = (e) => {
          if (!hadEditAccess()) {
            toast.error(
              t("Vous n'avez pas les droits pour modifier cette facture."),
              {
                position: "top-right",
                autoClose: 5000,
              },
            );
            return;
          }
          const inv = params.row;
          if (inv.status_infos.name === "annuler") {
            toast.error(
              t(
                "Vous pouvez pas modifier une facture annuler suite à une facture d'avoir !",
              ),
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
              },
            );
          } else {
            navigate(`/invoice/edit/${inv.id}`);
          }
        };

        const onDetails = (e) => {
          const inv = params.row;
          navigate(`/invoice/details/${inv.id}`);
        };

        /**
         * @param e
         */
        const emailInvoice = async (e) => {
          const { value: formValues } = await Swal.fire({
            title: "Ajoutez une remarque à votre facture à envoyer (optionnel)",
            html: `<textarea id="remarque" class="swal2-input"></textarea>`,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Envoyer",
            cancelButtonText: t("Cancel"),
            preConfirm: () => {
              return [document.getElementById("remarque").value];
            },
          });

          if (formValues) {
            const id = toast.loading(
              "Votre email est en cours d'envoi, veuillez ne pas fermer la fenêtre.",
              {
                position: "top-center",
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              },
            );

            const inv = {
              ...params.row,
              remarque: formValues[0],
            };

            console.log(inv);
            await jwtInterceoptor
              .post("/factures/send", inv)
              .then((res) => {
                toast.update(id, {
                  render: "Votre email a été envoyé avec succès.",
                  type: "success",
                  isLoading: false,
                });
              })
              .catch((error) => console.log(error));
          }
        };

        const onPrint = (e) => {
          setRowParam(params.row);
        };

        return (
          <div className="btn-list">
            <button
              onClick={onEdit}
              id="bEdit"
              type="button"
              className="btn  btn-sm btn-primary"
            >
              <span className="fe fe-edit"> </span>
            </button>

            <button
              onClick={onDetails}
              id="bEdit"
              type="button"
              className="btn  btn-sm btn-primary"
              title={"Voir les détails"}
            >
              <span class="fe fe-eye"> </span>
            </button>

            <button
              onClick={onPrint}
              id="bPrint"
              type="button"
              className="btn  btn-sm btn-warning"
              data-bs-toggle="modal"
              data-bs-target="#printModel"
              title={"Imprimer"}
            >
              <span className="fe fe-save"> </span>
            </button>

            <button
              onClick={onDelete}
              id="bDel"
              type="button"
              className="btn  btn-sm btn-danger"
              title={"Supprimer"}
            >
              <span className="fe fe-trash-2"> </span>
            </button>
            <button
              onClick={emailInvoice}
              id="bDel"
              type="button"
              className="btn  btn-sm btn-danger"
              title={"Envoyer par email"}
            >
              <span className="fe fe-mail"> </span>
            </button>
          </div>
        );
      },
    },
  ];

  

  const print = async (data, docType) => {
  // Vérifier le modèle uniquement pour la facture
if (!organisation?.invoice_model_id)  {
    Swal.fire({
      icon: "warning",
      title: t("Attention"),
      text: t("Aucun modèle de facture n'est actuellement sélectionné."),
    });
    return;
  }

  const { value: formValues } = await Swal.fire({
    title: "Ajouter une remarque à votre " + docType + " (optionnel)",
    html: `
      <textarea id="remarque" class="swal2-input"></textarea>
    `,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: "Télécharger",
    cancelButtonText: t("Cancel"),
    preConfirm: () => {
      return [document.getElementById("remarque").value];
    },
  });

  if (formValues) {
    if (docType === "facture") {
      const response = await jwtInterceoptor.post(
        `/data/user/factures/generate/${data.id}`,
        { remarque: formValues[0] },
        { responseType: "arraybuffer" },
      );

      if (response.status === 200) {
        const type = response.headers["content-type"];

        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = data.invoice_number + "V" + data.id;
        link.click();
      }
    } else {
      const response = await jwtInterceoptor.post(
        `/data/user/bnlivraison/generate/f/${data.id}`,
        { remarque: formValues[0] },
        { responseType: "arraybuffer" },
      );

      if (response.status === 200) {
        const type = response.headers["content-type"];

        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "BON DE LIVRAISON";
        link.click();
      }
    }
  }
};
  const handleStatusChange = (e) => {
    setNewStatus(e.target.value);
  };

  const editInvoiceStatus = async () => {
    let status = {};
    console.log("currentSelectedInvoice : ", currentSelectedInvoice);
    console.log("newStatus : ", newStatus);
    status = {
      id: currentSelectedInvoice,
      new_status: newStatus,
    };
    $("#exampleModal").hide();
    $(".modal-backdrop").css({
      "background-color": "transparent",
      display: "none",
    });
    const response = await jwtInterceoptor
      .post("/data/user/factures/status/", status)
      .then((res) => {
        console.log("has been edited: ", res.data.data);
        fetchInvoices();
        Swal.fire(t("Le status est modifier avec succés"), t(""), "success");
      })
      .catch((error) => console.log("error while save", error));
  };

  const downloadEtatFac = async () => {
    if (!selectedRow || selectedRow.length === 0) {
      console.warn("Aucune facture sélectionnée");
      return;
    }

    const getMoyenPaiement = (facture) => {
      if (facture.payment && facture.payment.length > 0) {
        const paiement = facture.payment[facture.payment.length - 1];

        if (paiement.banquePaymentOption) return "Banque";
        if (paiement.chequeId) return "Chèque";
        if (paiement.effetId) return "Effet";
        if (paiement.payment_account) return "Caisse";

        return "Crée";
      }
      return "N/A";
    };
    // calcule montants

    // Nouvelle structure qui affiche les produits sur des lignes distinctes
    const donneesFormatees = [];
    let totalQte = 0;
    let totalPrixHT = 0;
    let totalPaiement = 0;
    let totalNetAPayer = 0;
    let totalResteAPayer = 0;
    let totalTva = 0;

    // Parcourir chaque facture
    selectedRow.forEach((facture) => {
      // Récupérer le montant réellement payé (payed_amount)
      // const montantPaye = facture.payed_amount
      //   ? Number(facture.payed_amount)
//      console.log("FACTURE ETAT :", facture);
// console.log("CLIENT ETAT :", facture.client);
      //   : (facture.payment && facture.payment.length > 0 ? Number(facture.payment[facture.payment.length-1].payed_amount || 0) : 0);
      const montantPaye =
        facture.status == 2
          ? facture.total_ttc
          : facture.payment.reduce((acc, paiement) => {
              acc += Number(paiement.payed_amount);
              return acc;
            }, 0);

      const netAPayer = Number(facture.total_ttc || 0);
      const tva =
        facture.total_tva !== undefined && facture.total_tva !== null
          ? Number(facture.total_tva) || 0
          : netAPayer - Number(facture.total_ht || 0);
      const resteAPayer = netAPayer - montantPaye;

      // Ajouter au total des paiements seulement une fois par facture
      totalPaiement += montantPaye;
      totalNetAPayer += netAPayer;
      totalResteAPayer += resteAPayer;
      totalTva += tva;

      console.log("montantPaye", montantPaye);
      console.log("tva", tva);
      // Si la facture a des produits (ce qui est toujours le cas d'après vos informations)
      if (facture.products && facture.products.length > 0) {
        // Pour chaque produit de la facture
        facture.products.forEach((item, index) => {
          // Calculer les totaux
          const qte = Number(item.qty || 0);
          const prixUnitHT = Number(item.price_unit_ht || 0);
          const prixHT = Number(item.total_ht || 0);

          totalQte += qte;
          totalPrixHT += prixHT;

          // Ajouter une ligne pour ce produit
          donneesFormatees.push({
            date_facture: facture.created_at?.split("T")[0] || "N/A",
            date_echeance: facture.due_date?.split("T")[0] || "N/A",
            num_facture: facture.invoice_number || "N/A",
            num_pieces: facture.id || "N/A",
            compte_client: facture.client?.account || "N/A",
            // nom_client: facture.client?.name || "N/A",
            nom_client: facture.client?.companyName || "N/A",
            ice_client: facture.client?.ice || "N/A",
            nom_article: item.product?.name || item.details || "N/A",
            val_pu_ht: prixUnitHT,
            val_qte: qte,
            val_pt_ht: prixHT,
            date_paiement:
              facture.payment && facture.payment.length > 0
                ? facture.payment[facture.payment.length - 1].created_at?.split(
                    "T",
                  )[0] || "N/A"
                : "N/A",
            val_paiement: montantPaye, // Afficher le paiement uniquement sur la première ligne
            mode_paiement: getMoyenPaiement(facture), // Afficher le mode de paiement uniquement sur la première ligne
            val_net_a_payer: netAPayer,
            val_reste_a_payer: resteAPayer,
            val_tva: tva,
          });
        });
      }
    });

    // Ajouter une ligne de total avec la nouvelle structure
    donneesFormatees.push({
      date_facture: "",
      date_echeance: "",
      num_facture: "",
      num_pieces: "",
      compte_client: "",
      nom_client: "",
      ice_client: "",
      nom_article: "TOTAL",
      val_pu_ht: "",
      val_qte: totalQte.toFixed(2),
      val_pt_ht: totalPrixHT.toFixed(2),
      date_paiement: "",
      val_paiement: totalPaiement.toFixed(2),
      mode_paiement: "",
      val_net_a_payer: totalNetAPayer.toFixed(2),
      val_reste_a_payer: totalResteAPayer.toFixed(2),
      val_tva: totalTva.toFixed(2),
    });

    const { value: fileType } = await Swal.fire({
      title: "Choisissez le format de téléchargement",
      input: "radio",
      inputOptions: {
        csv: "CSV",
        pdf: "PDF",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Vous devez choisir une option!";
        }
      },
      showCancelButton: true,
      confirmButtonText: "Télécharger",
      cancelButtonText: "Annuler",
    });

    if (fileType === "csv") {
      const csv = Papa.unparse(donneesFormatees, { delimiter: ";" });
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "etat_factures.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (fileType === "pdf") {
      const { jsPDF } = await import("jspdf");
      const autoTable = (await import("jspdf-autotable")).default;

      const doc = new jsPDF({ orientation: "landscape" });
      const headerHeight = 30;
      const logoWidth = 30;
      const logoHeight = 15;
      const organisationName = organisation?.name || "Nom de l'organisation";
      const tirageDate = `Date de tirage : ${moment().format(
        "DD/MM/YYYY à HH:mm",
      )}`;
      doc.setFontSize(10);
      doc.text(organisationName, 10, 15);
      try {
        const logoX = (doc.internal.pageSize.width - logoWidth) / 2; // Centrer horizontalement
        doc.addImage(logo, "PNG", logoX, 5, logoWidth, logoHeight); // Position : centré, 5 (y)
      } catch (error) {
        console.error("Erreur lors de l'ajout du logo :", error);
      }

      // Ajouter le titre sous le logo
      doc.setFontSize(12);
      doc.text("État de Facturations", doc.internal.pageSize.width / 2, 25, {
        align: "center",
      }); // Centré horizontalement

      // Ajouter la date de tirage à droite
      doc.setFontSize(10);
      const tirageX = doc.internal.pageSize.width - 10; // Aligné à droite
      doc.text(tirageDate, tirageX, 15, { align: "right" });

      // Ajouter une ligne pour séparer l'en-tête
      doc.line(
        10,
        headerHeight,
        doc.internal.pageSize.width - 10,
        headerHeight,
      );

      // Définir les colonnes avec les mêmes noms que dans le CSV
      const columns = [
        "Date Facture",
        "Date Échéance",
        "Numéro Facture",
        "N° Pièce",
        "Compte Client",
        "Nom Client",
        "ICE Client",
        "Nom Article",
        "PU HT",
        "Qté",
        "PT HT",
        "Date Paiement",
        "Montant Payé",
        "Mode Paiement",
        "Net à payer ",
        "Reste à payer ",
        "TVA",
      ];

      // Transformer les données pour le PDF en utilisant les mêmes champs que le CSV
      const rows = donneesFormatees.map((facture) => [
        facture.date_facture,
        facture.date_echeance,
        facture.num_facture,
        facture.num_pieces,
        facture.compte_client,
        facture.nom_client,
        facture.ice_client,
        facture.nom_article,
        typeof facture.val_pu_ht === "number"
          ? facture.val_pu_ht.toFixed(2)
          : facture.val_pu_ht,
        facture.val_qte,
        typeof facture.val_pt_ht === "number"
          ? facture.val_pt_ht.toFixed(2)
          : facture.val_pt_ht,
        facture.date_paiement,
        typeof facture.val_paiement === "number"
          ? facture.val_paiement.toFixed(2)
          : facture.val_paiement,
        facture.mode_paiement,
        typeof facture.val_net_a_payer === "number"
          ? facture.val_net_a_payer.toFixed(2)
          : facture.val_net_a_payer,
        typeof facture.val_reste_a_payer === "number"
          ? facture.val_reste_a_payer.toFixed(2)
          : facture.val_reste_a_payer,
        typeof facture.val_tva === "number"
          ? facture.val_tva.toFixed(2)
          : facture.val_tva,
      ]);

      // Appliquer des styles spécifiques pour la ligne de total
      const rowStyles = rows.map((_, index) =>
        index === rows.length - 1
          ? { fontStyle: "bold", fillColor: [240, 240, 240] }
          : {},
      );

      // Générer le tableau avec l'en-tête
      autoTable(doc, {
        head: [columns],
        body: rows,
        startY: headerHeight + 10,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [61, 49, 155] }, // Couleur de l'en-tête
        rowStyles: rowStyles, // Appliquer les styles pour chaque ligne
      });

      // Télécharger le PDF
      doc.save("etat_factures.pdf");
    }
  };

  return (
    <>
      <ToastContainer />

      <div className="row" style={{ zIndex: 1 }}>
        <div className="col-lg-12">
          <div className="card">
            <div
              className="card-header container-fluid"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div className="col-md-9 col-sm-12 card-title">
                {t("Liste des factures de vente")}
              </div>
              <div className="col-md-3 card-title">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    navigate("/facture/add");
                  }}
                >
                  Ajouter une facture de vente
                </button>
              </div>
            </div>
            <div className="card-body">
              <div
                class="modal fade"
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="exampleModalLabel">
                        Changer le status de votre factrue
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Status*</label>
                        <div className="input-group mb-3">
                          <select
                            className="form-select"
                            id="inputGroupSelect01"
                            onChange={handleStatusChange}
                            value={newStatus}
                          >
                            {status.map((s) => (
                              <option
                                value={s.id}
                                selected={s.id === currentSelectedStatus}
                              >
                                {s.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Annuler
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={editInvoiceStatus}
                      >
                        Modifier
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="modal fade"
                id="printModel"
                tabIndex="-1"
                aria-labelledby="printModelLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="printModelLabel">
                        Générer et imprimer
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <div className="form-group">
                        <div className="input-group mb-3 genererEtImprimerPopupBtns">
                          <a
                            onClick={() => {
                              window.$("#printModel").modal("hide");
                              print(rowParam, "facture");
                            }}
                            className="btn btn-default"
                          >
                            {t("Facture de vente")}
                          </a>
                          <a
                            onClick={() => {
                              window.$("#printModel").modal("hide");
                              print(rowParam, "bon de livraison");
                            }}
                            className="btn btn-primary"
                          >
                            {t("Bon de livraison")}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* adding filtre de date */}
              <div className="mb-4 text-right d-flex ">
                <div className="col-3 mx-4">
                  <label htmlFor="dateDebut">{t("Date de début")}:</label>
                  <input
                    type="date"
                    className="form-control"
                    id="dateDebut"
                    value={dateDebut}
                    onChange={(e) => setDateDebut(e.target.value)}
                  />
                </div>
                <div className="col-3 mx-4">
                  <label htmlFor="dateFin">{t("Date de fin")}:</label>
                  <input
                    type="date"
                    className="form-control"
                    id="dateFin"
                    value={dateFin}
                    onChange={(e) => setDateFin(e.target.value)}
                  />
                </div>
                <div className="col-4 ">
                  <button
                    className="btn btn-primary mx-4 mt-5"
                    onClick={handleFilterDate}
                  >
                    {t("Filter par date")}
                  </button>
                  {filteredInvoices.length !== 0 ? (
                    <button
                      className="btn btn-danger mt-5"
                      onClick={() => {
                        setFilteredInvoices([]);
                      }}
                    >
                      {t("Afficher tout")}
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="table-responsive">
                <div style={{ height: 600, width: "100%" }}>
                  {/*<ThemeProvider theme={theme}>*/}
                  <DataGrid
                    rows={filteredInvoices.length ? filteredInvoices : invoices}
                    columns={columns}
                    pagination={false}
                    initialState={{}}
                    checkboxSelection
                    columnVisibilityModel={
                      visibleColumns ? visibleColumns : columns
                    }
                    onColumnVisibilityModelChange={
                      handleColumnVisibilityModelChange
                    }
                    localeText={
                      i18n.language == "fr"
                        ? frFR.components.MuiDataGrid.defaultProps.localeText
                        : enUS.components.MuiDataGrid.defaultProps.localeText
                    }
                    slots={{
                      toolbar: GridToolbar,
                      loadingOverlay: LinearProgress,
                    }}
                    slotProps={{
                      toolbar: {
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },
                      },
                    }}
                    loading={loadingData}
                    onRowSelectionModelChange={(ids) => {
                      console.log("ids", ids);
                      const selectedIDs = new Set(ids);
                      const selectedRowData = invoices.filter((row) =>
                        selectedIDs.has(row.id),
                      );
                      setSelectedRow(selectedRowData);
                      console.log(selectedRowData);
                      let totalAmount = selectedRowData.reduce(
                        (accumulator, inv) => {
                          return accumulator + inv.total_ttc;
                        },
                        0,
                      );
                      setGrandTotal(totalAmount);
                    }}
                  />
                  {/*</ThemeProvider>*/}
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="row">
                <div className="col">
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadEtatFac()}
                  >
                    Telecharger etat de facturation
                  </button>
                </div>
                <div className="col">
                  {grandTotal ? (
                    <div className="d-flex flex-row-reverse">
                      <span
                        className="text-success"
                        style={{
                          fontSize: 19,
                          fontWeight: "bold",
                        }}
                      >
                        {t("Total général")} {Number(grandTotal).toFixed(2)}{" "}
                        {organisation?.currency?.code} TTC
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InvoicesList;
